import { Injectable } from '@angular/core';
import { LogEvent } from '../models';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LogSession } from '../models/log-session.model';
import { ChatContext } from './notification.service';

@Injectable()
export class LoggingService {

  private session: LogSession;

  public disableLogging: boolean = false;

  constructor(private http: HttpClient) {
    this.session = new LogSession();
  }

  logEvent(event: LogEvent): void {
    if (this.disableLogging) return;

    const logData = { ...this.session, ...event };
    this.http
      .post('/api/proactive/LogEvent', logData)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
          } else {
            console.error(`Server error occurred (${error.status}).  Body was: ${JSON.stringify(error.error)}`);
          }
          return throwError('Failed to log Proactive chat event details');
        })
      )
      .subscribe(() => {
        console.log("Successfully log Proactive chat event details.", logData);
      });
  }

  updateChatContext(context: ChatContext) {
    this.session.ExternalSessionCode = context.sessionId;
    this.session.ReportingTag = context.chatRuleData.ReportingTag;
    this.session.SourceUrl = context.location.pathname;
    this.session.SourceUrlTitle = context.title;
  }
}
